import { AppData } from "../../AppDataProvider";
import { Mixpanel } from "../../../mixpanel";

export type BackFromRecurringBookingStepOpts = {
  appData: AppData;
};

export const backFromRecurringBookingStep = (
  options: BackFromRecurringBookingStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "recurringBooking" } });

  const appData = options.appData;
  const { bookingData } = appData;

  const updatedBookingData = {
    ...bookingData,
  };
  delete updatedBookingData.recurringBooking;

  return {
    ...appData,
    bookingData: updatedBookingData,
    currentStep: "availability",
  };
};
